import { render, staticRenderFns } from "./QuitarContrato.vue?vue&type=template&id=5c7f6e3b&scoped=true"
import script from "./QuitarContrato.vue?vue&type=script&lang=js"
export * from "./QuitarContrato.vue?vue&type=script&lang=js"
import style0 from "./QuitarContrato.vue?vue&type=style&index=0&id=5c7f6e3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7f6e3b",
  null
  
)

export default component.exports